export default "__VITE_ASSET__DJaMWKVY__"